import { Injectable } from "@angular/core";
import { ITCIAppConfiguration, ITCIAppProperty, TCI_APP_PROPERTY_TYPE } from "@tci/common";
import { ApplicationEnvCtrlAppProperty } from "../../base-app-detail-env.interface";
import { BaseAppDetailEnvService } from "../../base-app-detail-env.service";

@Injectable()
export class BaseSubmenuAppVarsService {
    private highLightRow: Array<boolean>;
    private isShowCalendar = false;
    private isShowPassword = false;
    private isDisableField = true;
    private originalResData: ITCIAppConfiguration;

    constructor(private envCtrlSvc: BaseAppDetailEnvService) {
    }

    getEnvCtrlService() {
        return this.envCtrlSvc;
    }

    getISODateFormat(dateStr: Date): string {
        const date = new Date(dateStr);
        const tzo = -date.getTimezoneOffset(),
            dif = tzo >= 0 ? "+" : "-",
            pad = function(num) {
                const norm = Math.floor(Math.abs(num));
                return (norm < 10 ? "0" : "") + norm;
            };
        return date.getFullYear() +
            "-" + pad(date.getMonth() + 1) +
            "-" + pad(date.getDate()) +
            "T" + pad(date.getHours()) +
            ":" + pad(date.getMinutes()) +
            ":" + pad(date.getSeconds()) +
            dif + pad(tzo / 60) +
            ":" + pad(tzo % 60);
    }

    formatDateTimeForProperty(item: ApplicationEnvCtrlAppProperty): ApplicationEnvCtrlAppProperty {
        if (item.datatype === TCI_APP_PROPERTY_TYPE.datetime) {
            item.dateValue = new Date(item.value);
        }
        return item;
    }

    formatDataForProperty(item: ApplicationEnvCtrlAppProperty): ApplicationEnvCtrlAppProperty {
        item.value = item.value.toString();
        item = this.formatDateTimeForProperty(item);
        return item;
    }

    setOriginalResData(resData: ITCIAppConfiguration) {
        this.originalResData = resData;
    }

    getOriginalResData(): ITCIAppConfiguration {
        return this.originalResData;
    }

    getOriginalProperties(): ITCIAppProperty[] {
        return this.originalResData.properties;
    }

    getOriginalPropertyOverrides(): ITCIAppProperty[] {
        return this.originalResData.propertyOverrides;
    }

    getOriginalUserSysProperties(): ITCIAppProperty[] {
        return this.originalResData.userSysProperties;
    }

    getOriginalNativeSysProperties(): ITCIAppProperty[] {
        return this.originalResData.nativeSysProperties;
    }

    getOriginalNativeSysPropertyOverrides(): ITCIAppProperty[] {
        return this.originalResData.nativeSysPropertyOverrides;
    }

    setIsDisableField(isDisableField: boolean) {
        this.isDisableField = isDisableField;
    }

    getIsDisableField(): boolean {
        return this.isDisableField;
    }

    toggleDisplayPassword() {
        if (!this.isDisableField) {
            this.isShowPassword = !this.isShowPassword;
        }
    }

    getIsShowPassword(): boolean {
        return this.isShowPassword;
    }

    hideDatePicker() {
        this.isShowCalendar = false;
    }

    toggleDisplayCalendar() {
        if (!this.isDisableField) {
            this.isShowCalendar = !this.isShowCalendar;
        }
    }

    getIsShowCalendar(): boolean {
        return this.isShowCalendar;
    }

    isRowHighLight(i: number): boolean {
        return this.highLightRow[i] || false;
    }
    initHighLightRow(size: number) {
        this.highLightRow = Array(size).fill(false);
    }
    setHighLightRow(i: number) {
        this.highLightRow = [];
        this.highLightRow[i] = true;
    }
}
